import { createRoute } from "@tanstack/react-router";
import { appAuthRoute } from "./index";
import { checkPermissionsAndRedirect } from "../../helpers/checkPermissions";
import Spinner from "../../components/general/Spinner";

const tikTokConnectRoute = createRoute({
  getParentRoute: () => appAuthRoute,
  path: "tik-tok-connect",
  beforeLoad: () =>
    checkPermissionsAndRedirect([
      { feature: "tikTokConnect", action: "READ" },
    ]),
  staticData: {
    breadcrumb: "TikTok Connect",
  },
  pendingComponent: Spinner
}).lazy(() =>
  import("./tikTokConnect.lazy").then((d) => d.TikTokConnectRoute)
);

export default tikTokConnectRoute;
